var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vue-tags-input',{attrs:{"tags":_vm.tags,"add-on-key":[9,13],"max-tags":5},on:{"tags-changed":function($event){_vm.updateTags($event)}},model:{value:(_vm.tag),callback:function ($$v) {_vm.tag=$$v},expression:"tag"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }